import { useId } from 'react'

const LitmusPaper = ({
  color = 'red',
  onClick,
  active = false,
  disabled = false,
  dipping = false
}) => {
  const id = useId()
  const paperColor = color === 'red' ? '#DC2626' : '#2563EB'
  const paperColorLight = color === 'red' ? '#F87171' : '#60A5FA'

  return (
    <svg
      viewBox="0 0 45 110"
      width={40}
      height={100}
      onClick={disabled ? undefined : onClick}
      style={{
        cursor: disabled ? 'default' : onClick ? 'pointer' : 'default',
        opacity: disabled ? 0.5 : 1,
        transition: 'all 0.3s ease',
        transform: dipping ? 'translateY(10px)' : 'translateY(0)'
      }}
    >
      <defs>
        {/* Paper gradient */}
        <linearGradient id={`paper-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor={paperColor} />
          <stop offset="50%" stopColor={paperColorLight} />
          <stop offset="100%" stopColor={paperColor} />
        </linearGradient>

        {/* Handle gradient */}
        <linearGradient id={`handle-${id}`} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#F8F4E8" />
          <stop offset="50%" stopColor="#FFFBEB" />
          <stop offset="100%" stopColor="#F8F4E8" />
        </linearGradient>

        {/* Shadow */}
        <filter id={`shadow-${id}`} x="-15%" y="-5%" width="130%" height="115%">
          <feDropShadow dx="2" dy="2" stdDeviation="2" floodOpacity="0.2"/>
        </filter>
      </defs>

      {/* Active glow */}
      {active && (
        <rect
          x="5" y="3" width="35" height="88" rx="4"
          fill="none"
          stroke="var(--primary)"
          strokeWidth="2.5"
          style={{ animation: 'glow 1.5s ease-in-out infinite' }}
        />
      )}

      <g filter={`url(#shadow-${id})`}>
        {/* Handle (top part) */}
        <rect
          x="10" y="5" width="25" height="22"
          fill={`url(#handle-${id})`}
          stroke="#C9A227"
          strokeWidth="1.5"
          rx="3"
        />

        {/* Handle texture lines */}
        <line x1="14" y1="10" x2="31" y2="10" stroke="#D4AF37" strokeWidth="0.8" opacity="0.5" />
        <line x1="14" y1="14" x2="31" y2="14" stroke="#D4AF37" strokeWidth="0.8" opacity="0.5" />
        <line x1="14" y1="18" x2="31" y2="18" stroke="#D4AF37" strokeWidth="0.8" opacity="0.5" />
        <line x1="14" y1="22" x2="31" y2="22" stroke="#D4AF37" strokeWidth="0.8" opacity="0.5" />

        {/* Paper strip */}
        <rect
          x="13" y="27" width="19" height="58"
          fill={`url(#paper-${id})`}
          stroke="#666"
          strokeWidth="0.5"
          rx="1"
        />

        {/* Paper texture lines */}
        <line x1="16" y1="35" x2="29" y2="35" stroke="rgba(0,0,0,0.1)" strokeWidth="0.5" />
        <line x1="16" y1="45" x2="29" y2="45" stroke="rgba(0,0,0,0.1)" strokeWidth="0.5" />
        <line x1="16" y1="55" x2="29" y2="55" stroke="rgba(0,0,0,0.1)" strokeWidth="0.5" />
        <line x1="16" y1="65" x2="29" y2="65" stroke="rgba(0,0,0,0.1)" strokeWidth="0.5" />
        <line x1="16" y1="75" x2="29" y2="75" stroke="rgba(0,0,0,0.1)" strokeWidth="0.5" />
      </g>

      {/* Label - larger and clearer */}
      <text
        x="22.5" y="100"
        fontSize="11"
        fill="var(--text-primary)"
        textAnchor="middle"
        fontWeight="600"
      >
        Litmus
      </text>
    </svg>
  )
}

export default LitmusPaper
